import { forwardRef, HTMLProps } from 'react'

type InputProps = HTMLProps<HTMLInputElement>

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, id, readOnly, type = 'text', ...rest }, ref) => (
    <div className={`mb-2 ${className ? className : "w-full"}`}>
      <label htmlFor={id} data-content={label} className="font-semibold text-sm">
        {label}
      </label>
      <input
        id={id}
        className={
          `flex h-9 rounded-md border border-input px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 mt-1 w-full`
        }
        type={type}
        name={label}
        ref={ref}
        role="presentation"
        autoComplete="off"
        {...rest}
      />
    </div>
  )
)

export default Input
